import {ReactNode} from 'react';

import {Box} from '@mui/material';

interface SplitStatusPillProps {
  icon?: ReactNode;
  text: string;
  backgroundColor: string;
  textColor: string;
  id?: string;
  fullWidth?: boolean;
}

export const SplitStatusPill = ({
  icon,
  text,
  backgroundColor,
  textColor,
  id,
  fullWidth = false,
}: SplitStatusPillProps) => {
  return (
    <Box
      id={id}
      className="split-status-pill"
      style={{backgroundColor, width: fullWidth ? '100%' : 'auto'}}>
      {icon && <span className="split-status-pill-icon">{icon}</span>}
      <span
        className="split-status-pill-text"
        style={{color: textColor}}>
        {text}
      </span>
    </Box>
  );
};
